<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>

    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Début</label>
          <datepicker
            v-model="form.begin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          />
        </div>
        <div class="form-group col-sm-6">
          <label>Fin</label>
          <datepicker
            v-model="form.end"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <label>Rechercher un prestataire</label>
          <input
            class="form-control"
            v-model="form.coach"
            placeholder="Rechercher un prestataire"
          />
        </div>
        <div class="form-group col-sm-6">
          <label>Société</label>
          <v-select
            :options="merchantOptions"
            v-model="form.merchant"
            :reduce="({ value }) => value"
          ></v-select>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <button type="button" class="btn btn-sm btn-secondary" @click="load()">
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    vSelect,
    Datepicker,
  },

  props: {
    default: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      form: {
        begin: null,
        end: null,
        coach: null,
        merchant: null,
      },
    };
  },

  computed: {
    ...mapState({
      merchants: (state) => state.merchants,
    }),

    merchantOptions() {
      return this.merchants.map((m) => {
        return { label: m.name, value: m.id };
      });
    },
  },

  created() {
    if (this.default) {
      this.form = this.default;
    }
  },

  methods: {
    load() {
      this.$emit("load", this.form);
    },
  },
};
</script>
